export const NAVIGATION_BAR_TRANSLATIONS = {
  es: {
    // Navegación principal
    'nav.home': 'Inicio',
    'nav.templates': 'Plantillas',
    'nav.institutions': 'Centros educativos',
    'nav.users': 'Usuarios',
    'nav.projects': 'Proyectos',
    'nav.reports': 'Gráficos de resultados',
    'nav.settings': 'Configuraciones',
    'nav.forms': 'Formularios',

    // Elementos del menú
    'menu.home': 'Inicio',
    'menu.manageStatements': 'Administrar formularios',
    'menu.statementAssignment': 'Asignación de formularios',
    'menu.templates': 'Plantillas',
    'menu.dashboard': 'Inicio',
    'menu.myDeclarations': 'Mis formularios',
    'menu.reviews': 'Revisiones',
    'menu.users': 'Usuarios',
    'menu.reports': 'Reportes',
    'menu.projects': 'Proyectos',

    // Navegación móvil
    'nav.mobile.more': 'Más',
    'nav.mobile.institutions': 'Instituciones',
    'nav.mobile.users': 'Usuarios',
    'nav.moreOptions': 'Más opciones',

    // Opciones de administrador
    'nav.admin.report': 'Reportes',
    'nav.admin.projects': 'Proyectos',
    'nav.admin.templates': 'Plantillas',

    // Opciones de docente
    'nav.teacher.dashboard': 'Tablero',
    'nav.teacher.forms': 'Formularios',

    // Alt text para imágenes
    'nav.images.logo': 'Logo DeclaraBID',
    'nav.images.logoNav': 'Logo de navegación',
    'nav.images.bidLogo': 'Logo BID',

    // Notificaciones
    'nav.notifications.title': 'Notificaciones',
    'nav.notifications.empty': 'No hay notificaciones',

    // Menú de usuario
    'nav.user.profile': 'Perfil',
    'nav.user.settings': 'Configuración',
    'nav.user.logout': 'Cerrar sesión',

    // Breadcrumb
    'nav.breadcrumb.home': 'Inicio',
    'nav.breadcrumb.dashboard': 'Dashboard',
    'nav.breadcrumb.forms': 'Formularios',
    'nav.breadcrumb.feedback': 'Retroalimentación',
    'nav.breadcrumb.howItWorks': 'Cómo funciona',

    // Estados
    'nav.status.loading': 'Cargando...',
    'nav.status.error': 'Error de navegación',

    // Acciones
    'nav.actions.menu': 'Menú',
    'nav.actions.close': 'Cerrar',
    'nav.actions.open': 'Abrir',
    'nav.actions.toggle': 'Alternar',

    // Roles
    'nav.roles.admin': 'Administrador',
    'nav.roles.teacher': 'Docente',
    'nav.roles.director': 'Director',

    // Mensajes de error
    'nav.errors.navigationFailed': 'Error al navegar',
    'nav.errors.loadingFailed': 'Error al cargar la navegación',

    // Tooltips
    'nav.tooltips.home': 'Ir al inicio',
    'nav.tooltips.forms': 'Ver formularios',
    'nav.tooltips.notifications': 'Ver notificaciones',
    'nav.tooltips.profile': 'Ver perfil',
    'nav.tooltips.menu': 'Abrir menú',
  },
  en: {
    // Main navigation
    'nav.home': 'Home',
    'nav.templates': 'Templates',
    'nav.institutions': 'Educational centers',
    'nav.users': 'Users',
    'nav.projects': 'Projects',
    'nav.reports': 'Results charts',
    'nav.settings': 'Settings',
    'nav.forms': 'Forms',

    // Menu items
    'menu.home': 'Home',
    'menu.manageStatements': 'Manage forms',
    'menu.statementAssignment': 'Form assignment',
    'menu.templates': 'Templates',
    'menu.dashboard': 'Dashboard',
    'menu.myDeclarations': 'My forms',
    'menu.reviews': 'Reviews',
    'menu.users': 'Users',
    'menu.reports': 'Reports',
    'menu.projects': 'Projects',

    // Mobile navigation
    'nav.mobile.more': 'More',
    'nav.mobile.institutions': 'Institutions',
    'nav.mobile.users': 'Users',
    'nav.moreOptions': 'More options',

    // Admin options
    'nav.admin.report': 'Reports',
    'nav.admin.projects': 'Projects',
    'nav.admin.templates': 'Templates',

    // Teacher options
    'nav.teacher.dashboard': 'Dashboard',
    'nav.teacher.forms': 'Forms',

    // Alt text for images
    'nav.images.logo': 'DeclaraBID logo',
    'nav.images.logoNav': 'Navigation logo',
    'nav.images.bidLogo': 'BID logo',

    // Notifications
    'nav.notifications.title': 'Notifications',
    'nav.notifications.empty': 'No notifications',

    // User menu
    'nav.user.profile': 'Profile',
    'nav.user.settings': 'Settings',
    'nav.user.logout': 'Logout',

    // Breadcrumb
    'nav.breadcrumb.home': 'Home',
    'nav.breadcrumb.dashboard': 'Dashboard',
    'nav.breadcrumb.forms': 'Forms',
    'nav.breadcrumb.feedback': 'Feedback',
    'nav.breadcrumb.howItWorks': 'How it works',

    // Status
    'nav.status.loading': 'Loading...',
    'nav.status.error': 'Navigation error',

    // Actions
    'nav.actions.menu': 'Menu',
    'nav.actions.close': 'Close',
    'nav.actions.open': 'Open',
    'nav.actions.toggle': 'Toggle',

    // Roles
    'nav.roles.admin': 'Administrator',
    'nav.roles.teacher': 'Teacher',
    'nav.roles.director': 'Director',

    // Error messages
    'nav.errors.navigationFailed': 'Navigation failed',
    'nav.errors.loadingFailed': 'Failed to load navigation',

    // Tooltips
    'nav.tooltips.home': 'Go to home',
    'nav.tooltips.forms': 'View forms',
    'nav.tooltips.notifications': 'View notifications',
    'nav.tooltips.profile': 'View profile',
    'nav.tooltips.menu': 'Open menu',
  }
};
